import React, { useContext, useState, useEffect } from "react"

import queryString from "query-string"
import { navigate } from "gatsby"

import { GlobalAuthContext } from "../../context/authContext"

import { CHECKOUT_DATA } from "../../components/payment-options/payment-actions"

import Layout from "../../components/layout/layout"
import PaymentOptions from "../../components/payment-options/payment-options"
import PaySuccess from "../../components/payment-options/success"
import PayFailed from "../../components/payment-options/failed"
import BreadcrumbComponent from "../../components/breadcrumb/breadcrum"

const CheckOut = ({ location }) => {
  const { state, dispatch } = useContext(GlobalAuthContext)
  const [data, setData] = useState(true)
  const [loading, setLoading] = useState(true)

  let page = queryString.parse(location.search)
  useEffect(() => {
    page = queryString.parse(location.search) // eslint-disable-line react-hooks/exhaustive-deps
    try {
      const user = state.user || JSON.parse(localStorage.getItem("user"))
      const token = state.token || localStorage.getItem("token")
      if (
        user &&
        user.role === 3 &&
        token &&
        state.isAuthenticated &&
        state?.isEmailVerified &&
        state?.hasProfile
      ) {
        if (Object.keys(page).length < 1) {
          setLoading(true)
          CHECKOUT_DATA(setData, setLoading)
        }
      }

      if (user && user.role === 2) {
        navigate("/")
      }
      if (!user) {
        navigate("/login")
      }
    } catch (err) {
      dispatch({
        type: "LOGOUT",
      })
    }
  }, [state.isAuthenticated, location.search, state?.hasProfile]) // eslint-disable-line react-hooks/exhaustive-deps

  const pages = [{ name: "Home", link: "/" }]
  const currentPage = { link: "/checkout", name: "Checkout" }

  const renderOptional = () => {
    if (page && page.q === "success") {
      return <PaySuccess page={page} />
    } else if (page && page.q === "failed") {
      return <PayFailed />
    }
  }

  return (
    <Layout
      location={location}
      noVerification={true}
      isAuthenticated={state.isAuthenticated}
    >
      {page && page.type === "esewa" ? (
        renderOptional()
      ) : (
        <>
          <BreadcrumbComponent currentPage={currentPage} pages={pages} />
          <PaymentOptions data={data} loading={loading} />
        </>
      )}
    </Layout>
  )
}

export default CheckOut
